import PubSub from 'pubsub-js';
import Constants from '../Constants';

class BootstrapBreakpoints {

  constructor() {

    this.gridBreakpoints = ['xs','sm', 'md', 'lg', 'xl'];

    this.responsiveElements = {};
    
    this.gridBreakpoints.forEach(breakpoint => {
      let element = document.createElement('span');
      element.className = 'd-' + breakpoint +'-none';
      document.body.appendChild(element);
      this.responsiveElements[breakpoint] = element;
    });

    this.lastActiveBreakpoints = this.getActiveBreakpoints();

    window.addEventListener('resize', this.debounce(this.handleWindowResize, 100));
  }

  handleWindowResize = () => {
    let activeBreakpoints = this.getActiveBreakpoints();
    let breakpointChanged = false;

    this.gridBreakpoints.forEach(breakpoint => {
      if (activeBreakpoints[breakpoint] != this.lastActiveBreakpoints[breakpoint]) {
        breakpointChanged = true;
      }
    });    

    if (breakpointChanged) {
      this.lastActiveBreakpoints = activeBreakpoints;
      PubSub.publish(Constants.eventKeys.bootstrapBreakpointChanged, activeBreakpoints);
    }  
  };

  debounce(func, wait, immediate) {
    let timeout;
    return function() {
      let context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      }, wait);
      if (immediate && !timeout) func.apply(context, args);
    };
  }

  getActiveBreakpoints() {
    let activeBreakpoints = {};
    
    this.gridBreakpoints.forEach(breakpoint => {
      activeBreakpoints[breakpoint] = this.responsiveElements[breakpoint].offsetParent == null;
    });

    return activeBreakpoints;
  }
}

export let bootstrapBreakpoints = new BootstrapBreakpoints();